import { UnitQueueRowData } from '../../socket/stream-types';
import { UnitQueueStore } from '../../unit-queues/store/unit-queue-store';
import { QueueStore } from '../store/queue-store';

export function useIsUnitTimerAlerting(queueStore: QueueStore, data: UnitQueueRowData) {
    const unitQueueStore = queueStore as UnitQueueStore;

    if (unitQueueStore.getUnitTimer) {
        const unitTimer = unitQueueStore.getUnitTimer(data.id);
        if (
            unitTimer?.state === 'ALERTING' &&
            data.unitStateGroup &&
            !unitQueueStore.isSelected(data.id)
        ) {
            return true;
        }
    }
    return false;
}
